import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NgForm, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { BBWTMessageService } from '../../services';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [],
})
export class ForgotPasswordComponent implements OnInit {
  EmailForm: UntypedFormGroup;
  public Email: string;
  public msgs: Array<any>;

  loginUrl = '/account/login';

  constructor(
    private http: HttpClient,
    private router: Router,
    public messageService: BBWTMessageService,
  ) {
    this.msgs = [];
  }

  get f() {
    return this.EmailForm.controls;
  }

  ngOnInit() {
    this.Email = '';
    const regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    this.EmailForm = new UntypedFormGroup({
      emailAddress: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(254),
          Validators.pattern(regexp),
        ]),
      ),
    });
  }

  SendResetLink() {
    this.msgs = [];
    this.http
      .post('/api/account/recoverpassword', {
        Email: this.EmailForm?.controls?.emailAddress?.value,
      })
      .toPromise()
      .then((result: any) => {
        if (result.isSuccess == true) {
          window.location.href = `${this.loginUrl}?resetPassword=true`;
        } else {
          this.messageService.ShowError('Error.', result.error);
        }
      });
  }

  Cancel() {
    this.router.navigate(['/account']);
  }
}
